export default process.env.REACT_APP_STRIPE_API_KEY || 'pk_live_mNr8eUPdV2iNKMz1NayvYVHI';
// 'pk_live_mNr8eUPdV2iNKMz1NayvYVHI';
// TODO: HANDLE SWITCH OF KEY AT BUILD SIDE
// const apiKey = process.env.REACT_APP_STRIPE_API_KEY || 'pk_test_mxl4YCEpcDOwGuxCM0BgSCm2';
